var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#D19700",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13.0002C15.9391 13.0002 14.9217 13.4216 14.1716 14.1718C13.4214 14.9219 13 15.9393 13 17.0002C13 18.061 13.4214 19.0785 14.1716 19.8286C14.9217 20.5788 15.9391 21.0002 17 21.0002C18.0609 21.0002 19.0783 20.5788 19.8284 19.8286C20.5786 19.0785 21 18.061 21 17.0002C21 15.9393 20.5786 14.9219 19.8284 14.1718C19.0783 13.4216 18.0609 13.0002 17 13.0002ZM15 22.0002C13.9391 22.0002 12.9217 22.4216 12.1716 23.1718C11.4214 23.9219 11 24.9393 11 26.0002V27.0002C11 28.1002 11.9 29.0002 13 29.0002H21C21.5304 29.0002 22.0391 28.7895 22.4142 28.4144C22.7893 28.0393 23 27.5306 23 27.0002V26.0002C23 24.9393 22.5786 23.9219 21.8284 23.1718C21.0783 22.4216 20.0609 22.0002 19 22.0002H15ZM22.3 20.0002C22.8266 19.0881 23.1038 18.0534 23.1038 17.0002C23.1038 15.947 22.8266 14.9123 22.3 14.0002C22.8756 13.4735 23.5926 13.1266 24.3629 13.0023C25.1331 12.878 25.9229 12.9816 26.635 13.3004C27.347 13.6193 27.9503 14.1394 28.3705 14.7968C28.7908 15.4541 29.0096 16.22 29 17.0002C29.0096 17.7803 28.7908 18.5462 28.3705 19.2036C27.9503 19.861 27.347 20.3811 26.635 20.6999C25.9229 21.0188 25.1331 21.1224 24.3629 20.9981C23.5926 20.8737 22.8756 20.5269 22.3 20.0002ZM24.5 29.0002C24.8386 28.3886 25.0109 27.6991 25 27.0002V26.0002C25.0077 24.528 24.4738 23.1043 23.5 22.0002H27C28.0609 22.0002 29.0783 22.4216 29.8284 23.1718C30.5786 23.9219 31 24.9393 31 26.0002V27.0002C31 27.5306 30.7893 28.0393 30.4142 28.4144C30.0391 28.7895 29.5304 29.0002 29 29.0002H24.5Z",
    fill: "#D19700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBg);
export default __webpack_public_path__ + "static/media/user-bg.9551cf0b5ff6e5ca4069c2d9ee364a7a.svg";
export { ForwardRef as ReactComponent };